import { Typography } from "@mui/material";
import { SocialMediaHeaderDivStyles } from "../content/styles";
import FacebookShareButton from "./buttons/facebook-share-button";
import XShareButton from "./buttons/x-share-button";
import {useLocation} from "react-router-dom";
import {siteUrl} from "../../../seo/Seo";

export default function ShareButtons() {
  const location = useLocation();
  const currentUrl = `${siteUrl}${location.pathname}`;
  return (
    <div style={SocialMediaHeaderDivStyles}>
      <Typography color="text.primary" variant="body1" fontWeight="bold">
        Share
      </Typography>
      <XShareButton url={currentUrl} />
      <FacebookShareButton url={currentUrl} />
    </div>
  );
}
